import { FC } from 'react';
import type { KpiCardBlock as KpiCardBlockType } from '@/types/blocks';
import { Text } from '@/components/Typography';
import { resolveColor } from './themeColors';
import { useDarkMode } from '@/hooks/useDarkMode';
import { formatCompactNumber } from '@/utils/formatCompactNumber';

export const KpiCardBlock: FC<{ block: KpiCardBlockType }> = ({ block }) => {
  const isDark = useDarkMode();
  const desktopColsClass =
    block.items.length <= 1
      ? 'md:grid-cols-1'
      : block.items.length <= 4
        ? 'md:grid-cols-2'
        : 'md:grid-cols-3';

  return (
    <div>
      {block.title && (
        <Text variant="text-md-bold" className="mb-3 text-grey-black dark:text-grey-main-dark">
          {block.title}
        </Text>
      )}
      <div className={`grid grid-cols-1 ${desktopColsClass} gap-3`}>
        {block.items.map((item, i) => {
          const accentColor = resolveColor(item.color, isDark);
          const value = formatCompactNumber(item.value);
          const delta = item.delta ? formatCompactNumber(item.delta) : null;
          return (
            <div
              key={i}
              className="rounded-lg border border-peach-1 dark:border-grey-plain-dark bg-grey-light dark:bg-grey-sky-dark p-4"
            >
              <Text variant="text-sm-regular" className="text-grey-hover dark:text-grey-medium-dark mb-1">
                {item.label}
              </Text>
              <div className="flex items-baseline gap-2">
                <span
                  className="text-title-md font-bold"
                  style={{ color: accentColor }}
                >
                  {value}
                </span>
                {delta && (
                  <span
                    className="text-sm font-medium"
                    style={{ color: accentColor }}
                  >
                    {delta}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
